export default __webpack_public_path__ + "static/media/time-line-arrow.96d38378.svg";